module.exports = __webpack_public_path__ + "img/Point3.4cd2b918.png";